"use client";

import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { CallAnalysisOverviewMember } from "@/app/types/call/CallAnalysisOverview";
import styles from "./AnalysisOverview.module.css";
import TopicBars from "./TopicBars";

type Props = {
  members: CallAnalysisOverviewMember[];
  average: number | null;
};

export default function MembersChart(props: Props) {
  const T = useT();
  const { members, average } = props;

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>{T(TKey.CALL_OVERVIEW_MEMBERS_TITLE)}</span>

        {average !== null && (
          <span className={styles.cardHint}>
            {T(TKey.CALL_OVERVIEW_TEAM_AVERAGE)} {average}
          </span>
        )}
      </div>

      <TopicBars
        rows={members.map((member) => ({
          label: member.name,
          hint: String(member.score),
          colors: {
            color: "var(--color-green-3)",
            bg: "var(--color-green-4)",
          },
        }))}
      />
    </div>
  );
}
